import styled from 'styled-components';
import { Grid } from '@mui/material';
import { FC } from 'react';
import { extraColor } from '@styles/muiTheme';

export const RelativeWrapper = styled.div<{ fullHeight?: boolean }>`
  width: 100%;
  height: ${({ fullHeight }) => (fullHeight ? '100%' : 'auto')};
  position: relative;
`;

export const HiddenInput = styled.input`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
`;

export const hoverOpacity = `
  &:hover {
    opacity: .9;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GridItem: FC<{ width?: string; minWidth?: string; [key: string]: any }> = ({
  width,
  minWidth,
  children,
  ...rest
}) => (
  <Grid
    item
    sx={{ width, minWidth }}
    {...rest}
  >
    {children}
  </Grid>
);

export const PageWrapper = styled.div<{ padding?: string; direction?: string; minHeight?: string; justifyContent?: string }>`
  flex: 1;
  display: flex;
  padding: ${({ padding }) => padding || '20px'};
  flex-direction: ${({ direction }) => direction || 'column'};
  min-height: ${({ minHeight }) => minHeight || 'auto'};
  justify-content: ${({ justifyContent }) => justifyContent || 'inherit'};

  form {
    width: 100%;
  }
`;

export const ShadowDivider = styled.div<{ regular?: boolean; inverse?: boolean }>`
  width: ${({ regular }) => (regular ? '100%' : 'calc(100% + 40px)')};
  margin: ${({ regular }) => (regular ? 0 : '0 -20px')};
  height: 30px;
  z-index: 1;
  background: transparent
    linear-gradient(
      ${({ inverse }) => (inverse ? '0' : '180deg')},
      ${extraColor.palette.grey.dark} 0%,
      ${extraColor.palette.transparent.light} 100%
    )
    0% 0% no-repeat padding-box;
`;

export const ModalHeader = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.palette.secondary.light};
  color: ${({ theme }) => theme.palette.primary.dark};
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px 5px;

  p {
    margin: 0;
  }

  svg {
    cursor: pointer;
  }
`;

export const ModalContentContainer = styled.div`
  padding: 25px 20px 10px;
  audio {
    width: 450px;
  }
`;

export const GroupItems = styled('ul')({
  padding: 0,
  paddingLeft: '4px',
});

export const OptOutFormGridItem: FC<{ width?: string; minWidth?: string; [key: string]: any; isSubForm?: boolean }> = ({
  width,
  minWidth,
  isSubForm,
  children,
  ...rest
}) => (
  <GridItem
    sx={{
      width,
      minWidth: minWidth as string,
      ml: isSubForm && 10,
      pt: isSubForm && '0 !important',
      pl: isSubForm && '0 !important',
    }}
    {...rest}
  >
    {children}
  </GridItem>
);
